/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureVaultConfig {
  /**
  * The tenant ID of the Azure subscription.
  */
  'tenantId'?: string;
  /**
  * The storage account of the vault.
  */
  'storageAccount'?: string;
  /**
  * The resource group of the vault.
  */
  'resourceGroup'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageAccount",
      "baseName": "storageAccount",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroup",
      "baseName": "resourceGroup",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureVaultConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

